import React from "react"
import {Box, styled} from "@mui/material"
import TimelineDot from "./TimelineDot"

const DOT_INTERVAL = 5

const TimelineBox = styled(Box)(({theme}) => theme.TIMELINECOMPONENT.BOX)
const TimelineInnerBox = styled(Box)(({theme}) => theme.TIMELINECOMPONENT.INNERBOX)

const TimelineComponent = ({startDate, endDate}) => {
    const START_YEAR = Number(startDate ?? 1980)
    const END_YEAR = Number(endDate ?? 2050)

    const totalYears = END_YEAR - START_YEAR
    const yearsRange = Array.from(
        {length: Math.floor(totalYears / DOT_INTERVAL) + 1},
        (_, i) => START_YEAR + i * DOT_INTERVAL,
    )

    return (
        <>
            <TimelineBox>
                <TimelineInnerBox px={2}/>
            </TimelineBox>
            <Box width="100%" display="flex"
                 justifyContent="space-between" mt="-22px">
                {yearsRange.map((year) => (
                    <TimelineDot key={year} year={year}/>
                ))}
            </Box>
        </>
    )
}

export default TimelineComponent
